/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CustomerNotificationSettingDto, SaveCustomerNotificationSettingRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCustomerNotificationSettingsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-customer-notification-settings-controller
   * @name FindAllNotificationSettings
   * @request GET:/api/v1/customer-notification-settings
   */
  findAllNotificationSettings = (params: RequestParams = {}) =>
    this.http.request<CustomerNotificationSettingDto[], any>({
      path: `/v1/customer-notification-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAllNotificationSettingsPath = '/v1/customer-notification-settings'
  static findAllNotificationSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-customer-notification-settings-controller
   * @name UpdateNotificationSetting
   * @request PUT:/api/v1/customer-notification-settings
   */
  updateNotificationSetting = (
    data: SaveCustomerNotificationSettingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CustomerNotificationSettingDto, any>({
      path: `/v1/customer-notification-settings`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateNotificationSettingPath = '/v1/customer-notification-settings'
  static updateNotificationSettingMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-customer-notification-settings-controller
   * @name GetNotificationChannelConfiguration
   * @request GET:/api/v1/customer-notification-settings/channel-configuration
   */
  getNotificationChannelConfiguration = (params: RequestParams = {}) =>
    this.http.request<
      Record<string, ('EMAIL' | 'IN_APP' | 'PUSH_NOTIFICATION' | 'SLACK' | 'SMS')[]>,
      any
    >({
      path: `/v1/customer-notification-settings/channel-configuration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getNotificationChannelConfigurationPath =
    '/v1/customer-notification-settings/channel-configuration'
  static getNotificationChannelConfigurationMethod = 'GET'
}
